var map = {
	"./ai.wav": 4659,
	"./ao.wav": 6465,
	"./au.wav": 6770,
	"./auHat.wav": 9161,
	"./ay.wav": 4567,
	"./ayHat.wav": 9262,
	"./ch.wav": 6966,
	"./eo.wav": 2101,
	"./euHat.wav": 6815,
	"./gh.wav": 2574,
	"./gi.wav": 9095,
	"./ia.wav": 8868,
	"./ieHat.wav": 7522,
	"./ieuHat.wav": 1388,
	"./iu.wav": 9469,
	"./kh.wav": 8115,
	"./ng.wav": 1385,
	"./ngh.wav": 6969,
	"./nh.wav": 8314,
	"./oa.wav": 4568,
	"./oaSmile.wav": 6502,
	"./oai.wav": 8321,
	"./oay.wav": 887,
	"./oeo.wav": 6827,
	"./oi.wav": 3385,
	"./oiHat.wav": 4595,
	"./oiHook.wav": 4407,
	"./ph.wav": 691,
	"./qu.wav": 7800,
	"./th.wav": 7974,
	"./tr.wav": 2926,
	"./ua.wav": 3122,
	"./uaHat.wav": 324,
	"./uaHook.wav": 2075,
	"./uai.wav": 28,
	"./uao.wav": 6006,
	"./uau.wav": 9336,
	"./uay.wav": 4172,
	"./uayHat.wav": 9434,
	"./ue.wav": 6677,
	"./ueo.wav": 9446,
	"./ui.wav": 1610,
	"./uiHook.wav": 8074,
	"./uoHookO.wav": 588,
	"./uoHookU.wav": 1525,
	"./uoiHat.wav": 6733,
	"./uoiHook.wav": 7408,
	"./uouHook.wav": 2154,
	"./uuHook.wav": 9744,
	"./uya.wav": 3524,
	"./uyeHat.wav": 1025,
	"./uyu.wav": 2024,
	"./ye.wav": 676,
	"./yeuHat.wav": 3263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8251;